import { Outlet } from 'react-router-dom';

const SocialPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default SocialPage;
